import apiClient from './apiClient';

// Calendar sync (iCal) — generic per-hotel import/export of availability
// via .ics feeds. Admin CRUD lives under /v1/settings/ical-sync/* (same
// hotel-admin auth as every other /v1/settings surface); the public
// .ics export feed itself is unauthenticated and lives at
// /api/v1/ical/<token>.ics — its URL comes back in every feed payload.
const icalSyncService = {
  // Export feeds (FrontDesko -> OTA)
  listExportFeeds: () => apiClient.get('/v1/settings/ical-sync/export-feeds'),
  createExportFeed: (data) => apiClient.post('/v1/settings/ical-sync/export-feeds', data),
  updateExportFeed: (id, data) => apiClient.put(`/v1/settings/ical-sync/export-feeds/${id}`, data),
  deleteExportFeed: (id) => apiClient.del(`/v1/settings/ical-sync/export-feeds/${id}`),

  // Import sources (OTA -> FrontDesko)
  listImportSources: () => apiClient.get('/v1/settings/ical-sync/import-sources'),
  createImportSource: (data) => apiClient.post('/v1/settings/ical-sync/import-sources', data),
  updateImportSource: (id, data) => apiClient.put(`/v1/settings/ical-sync/import-sources/${id}`, data),
  deleteImportSource: (id) => apiClient.del(`/v1/settings/ical-sync/import-sources/${id}`),
  pollNow: (id) => apiClient.post(`/v1/settings/ical-sync/import-sources/${id}/poll-now`, {}),

  // Imported events / conflicts
  listImportedEvents: (sourceId) =>
    apiClient.get('/v1/settings/ical-sync/import-events', sourceId ? { source: sourceId } : undefined),
};

export default icalSyncService;
